module.exports = __webpack_public_path__ + "static/media/play_home_banner.0a3964f5.svg";